import LinePreloader from "@/components/common/preloaders/LinePreload.vue";
import isImgCorrect from "@/services/isImgCorrect.ts";
import Vue from "vue";

let isAlreadyLoad: boolean = false;

const addPreload = (el, opt = {}) => {
  const ComponentClass = Vue.extend(LinePreloader);
  const instance = new ComponentClass({ propsData: opt });
  instance.$mount();
  el.appendChild(instance.$el);
};

const removePreload = el => {
  el.innerHTML = "";
};

export default {
  bind: async (el, { value }) => {
    if (!isAlreadyLoad) {
      addPreload(el, "opt" in value ? value.opt : {});
      const isValid = await isImgCorrect(value.url);
      isAlreadyLoad = true;
      isValid ? removePreload(el) : null;
    }
  }
};
